import {
  Button,
  CardContent,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import './index.css';
type CreateChallengeFormProps = {
  onSubmit(data: {
    name: string;
    metrics: string[];
    description: string;
    levels: [number, number];
    env: string;
  }): void;
};

const CreateChallengeForm = ({ onSubmit }: CreateChallengeFormProps) => {
  const [metrics, setMetrics] = useState<string[]>([]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let data = new FormData(e.target as HTMLFormElement);
    let levelFrom = parseInt(data.get('level-from') as string);
    let levelTo = parseInt(data.get('level-to') as string);
    onSubmit({
      name: data.get('name') as string,
      description: data.get('desc') as string,
      metrics: metrics,
      levels: [levelFrom, levelTo],
      env: data.get('env') as string,
    });
  };

  const metricsOnChange = (e: any) => {
    let val: string = e.target.value;
    setMetrics(val.split(','));
  };

  return (
    <div className="CreateChallengeForm">
      <Paper elevation={3} className="submit-card">
        <CardContent>
          <Typography variant="h5" style={{ fontWeight: 700 }}>
            Create Challenge
          </Typography>
          <br />
          <form onSubmit={handleSubmit}>
            <TextField
              className="name"
              label="Name"
              color="primary"
              name="name"
              type="text"
              required
            />
            <TextField
              className="desc"
              label="Description"
              color="primary"
              name="desc"
              type="text"
              required
            />
            <TextField
              className="env"
              label="Environment"
              color="primary"
              name="env"
              type="text"
              required
            />
            <br />
            <Typography variant="body1">Level</Typography>
            <div className="level-selector">
              <Grid container>
                <Grid item xs={3}>
                  <TextField
                    className="level-from"
                    name="level-from"
                    type="number"
                    placeholder="From"
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    className="level-to"
                    name="level-to"
                    type="number"
                    placeholder="To"
                  />
                </Grid>
              </Grid>
            </div>
            <br />
            <TextField
              className="metrics"
              label="Metrics"
              color="primary"
              name="desc"
              type="text"
              required
              onChange={metricsOnChange}
            />
            <Typography
              variant="body2"
              color="textSecondary"
              className="metrics-note"
            >
              Enter metric names separated by commas (,)
            </Typography>
            <br />
            <br />
            <Button className={'submit-btn'} type="submit" variant="contained">
              Create
            </Button>
          </form>
        </CardContent>
      </Paper>
    </div>
  );
};

export default CreateChallengeForm;
